const _ = require('lodash');

function createFeatureCardDetail(card) {
    return {
        template: '<bws-feature-card-detail card="card"></bws-feature-card-detail>',
        data: { card }
    };
}

function createFeatureCard(featureCard) {
    return {
        template: '<bws-feature-card card="contentCard"></bws-feature-card>',
        data: { contentCard: featureCard },
        detail: createFeatureCardDetail(featureCard)
    };
}

function createFeatureCards(featureCards) {
    return _.map(featureCards, createFeatureCard);
}

module.exports = {
    createFeatureCard,
    createFeatureCards
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/feature-card/feature-card-factory.js
 **/